import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { NCFileLink } from '@interfaces/search';

import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import Svg from '@styles/icons/svg';
import { convertTimeLetter } from '@helpers';
import { WithColor } from '@styles/colors';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { renderTime } from '@components/ncFiles/components/links/helpers/renderTime';

interface LinkProps extends WithColor {
  link: NCFileLink;
  index?: number;
}

const Link = ({ C, link, index }: LinkProps) => {
  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: scale(76),
        gap: scale(5),
        borderRadius: scale(SCREEN_BORDER_RADIUS),
        paddingLeft: scale(10),
        paddingRight: scale(18),
        paddingVertical: scale(5),
        backgroundColor: C('Background/Light/Field'),
      }}
    >
      <View style={{ gap: scale(2), width: '30%' }}>
        <Text
          numberOfLines={1}
          {...(index !== undefined ? { testID: TEST_IDS.ncFileLinks.itemPartName(index) } : {})}
          style={[font.Headline, { color: C('Label/Light/Primary') }]}
        >
          {link.partName}
        </Text>
        <Text numberOfLines={1} style={[font['Subhead 2'], { color: C('Label/Light/Primary') }]}>
          {i18n.t('Drawing')} {link.drawingNumber}
        </Text>
        <Text numberOfLines={1} style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>
          {i18n.t('Recipe')}
        </Text>
      </View>
      <View style={{ gap: scale(2), flex: 1 }}>
        <Text
          numberOfLines={1}
          {...(index !== undefined ? { testID: TEST_IDS.ncFileLinks.itemOperationName(index) } : {})}
          style={[font.Headline, { color: C('Label/Light/Primary') }]}
        >
          {link.operationName}
        </Text>
        <Text numberOfLines={1} style={[font['Subhead 2'], { color: C('Label/Light/Primary') }]}>
          {renderTime(convertTimeLetter(link.operationTimeSeconds))} {i18n.t('cycle time')} | {renderTime(convertTimeLetter(link.setupTimeSeconds))}{' '}
          {i18n.t('Setup time')}
        </Text>
        <Text numberOfLines={1} style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>
          {link.operationShortDescription}
        </Text>
      </View>
      <View>
        <Svg icon="info" width={scale(20)} height={scale(20)} />
      </View>
    </View>
  );
};

export default Link;
